
export enum UserRole {
    CALCULATOR = 'ROLE_CALCULATOR',
    PREDICT_PRICE = 'ROLE_PREDICT_PRICE',
    FLIP = 'ROLE_FLIP',
    SUBSCRIBE = 'ROLE_SUBSCRIBE',
    AI_DATA = 'ROLE_AI_DATA'
}

export const hasRole = (role: UserRole, userRoles: string): boolean => {
    return userRoles.includes(role);
};
